/* @flow */

import {
  getMembershipId,
  getMembershipFlags,
} from '@braindate/domain/lib/membership/util';

import * as onboardingTypes from 'src/shared/app/onboarding/action/onboardingActionTypes';
import {
  createReducer,
  patchEntities,
} from 'src/shared/core/util/reducerUtils';
import * as entititesTypes from 'src/shared/domain/base/action/entityActionTypes';
import * as membershipTypes from 'src/shared/domain/membership/action/membershipActionTypes';

const initialState = {};

const _patch = (state: Object, action: Object) =>
  patchEntities(state, action, 'memberships');

const _completeOnboarding = (state: Object, action: Object) => {
  const { membershipId } = action;
  const membership = state[membershipId];

  if (membership) {
    const flags = getMembershipFlags(membership);

    return {
      ...state,
      [membershipId]: {
        ...membership,
        flags: {
          ...flags,
          onboarding_completed: true,
        },
      },
    };
  }
  return state;
};

const _updateGuidance = (state: Object, action: Object) => {
  const { guidance, membership } = action;
  const membershipId = getMembershipId(membership);
  const prevMembership = state[membershipId];

  return {
    ...state,
    [membershipId]: {
      ...prevMembership,
      guidance,
    },
  };
};

const _deleteGuidance = (state: Object, action: Object) => {
  const { membership } = action;
  const membershipId = getMembershipId(membership);
  const prevMembership = state[membershipId];

  return {
    ...state,
    [membershipId]: {
      ...prevMembership,
      guidance: {},
    },
  };
};

export default createReducer(initialState, {
  [entititesTypes.PATCH_ENTITIES]: _patch,
  [onboardingTypes.COMPLETE_ONBOARDING_OPTIMISTICALLY]: _completeOnboarding,
  [membershipTypes.FETCH_GUIDANCE_MARKET_PROMPT_SUCCESS]: _updateGuidance,
  [membershipTypes.DELETE_GUIDANCE_MARKET_PROMPT_SUCCESS]: _deleteGuidance,
});
